export default __webpack_public_path__ + "static/media/olivine32.f4030608.png";